import { IPagedData } from '@/types'

export const DataMock: IPagedData<any> = {
  count: 0,
  next: null,
  prev: null,
  results: [],
}
